import { render, staticRenderFns } from "./SignActionItem.vue?vue&type=template&id=53dc2df2&"
import script from "./SignActionItem.vue?vue&type=script&lang=js&"
export * from "./SignActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports